import { Field } from 'react-final-form'
import { FieldValidator } from 'final-form'
import { TextField, TextFieldProps } from '@forgeglobal/design-framework'
import { formatPercent, parsePercent } from 'util/NumberUtils'
import React from 'react'

interface PercentFieldProps {
  name: string
  label?: string
  validate?: FieldValidator<string>
  textFieldProps?: Partial<TextFieldProps<string>>
}

const formatStringToPercentage = (value?: string) => (value === undefined ? '' : formatPercent(parsePercent(value)))

export const PercentField: React.FC<PercentFieldProps> = ({ name, label, validate, textFieldProps }) => {
  return (
    <Field name={name} format={formatStringToPercentage} formatOnBlur validate={validate}>
      {props => <TextField label={label} helperText={props.meta.error} fullWidth {...textFieldProps} {...props} />}
    </Field>
  )
}
